import { ECrmTravelCompanyType } from 'services/CrmApi/types/DirectoryEntry';
import * as Yup from 'yup';

const commonFields = {
  companyTypeCode: Yup.string().required('Field is required'),
  name: Yup.string().required('Field is required'),
  tcType: Yup.string().nullable(true),
  industry: Yup.string(),
  employeeCount: Yup.number(),
  mobile: Yup.string(),
  email: Yup.string().email('Must be valid email'),
  website: Yup.string(),
  linkedin: Yup.string(),
  twitter: Yup.string(),
  instagram: Yup.string(),
  acceptsEmail: Yup.boolean(),
};

export const companyProfileFormValidationSchema = Yup.object().shape({
  ...commonFields,
  countryCode: Yup.string().nullable(true),
  address: Yup.string(),
  currencyCode: Yup.string().nullable(true),
});

export const travelCompanyPublishedProfileFormValidationSchema = Yup.object().shape({
  ...commonFields,
  countryCode: Yup.string().nullable(true).required('Field is required'),
  address: Yup.string().required('Field is required'),
  currencyCode: Yup.string().nullable(true),
});

export const supplierPublishedProfileFormValidationSchema = Yup.object().shape({
  ...commonFields,
  countryCode: Yup.string().nullable(true).required('Field is required'),
  address: Yup.string().required('Field is required'),
  currencyCode: Yup.string().nullable(true).required('Field is required'),
});

export const hotelPublishedProfileFormValidationSchema = Yup.object().shape({
  ...commonFields,
  countryCode: Yup.string().nullable(true).required('Field is required'),
  currencyCode: Yup.string().nullable(true).required('Field is required'),
});

export interface ICompanyProfileFormValues {
  companyTypeCode: string;
  name: string;
  tcType: ECrmTravelCompanyType | null;
  industry: string;
  countryCode: string | null;
  employeeCount: string;
  address: string;
  mobile: string;
  email: string;
  acceptsEmail?: boolean;
  website: string;
  linkedin: string;
  twitter: string;
  instagram: string;
  manager?: string;
  currencyCode: string | null;
}
